module.exports = __webpack_public_path__ + "img/illustration-remote.411c6928.svg";